import React, { useState } from 'react';
import { Icon } from '../../Icon';
import { parseBrazilianNumber } from '../../../utils/formatUtils';
import { FormField, ResultCard, EducationalBlock } from '../finance/shared';

const RatioProportionCalculator = ({ onResultChange }: { onResultChange: (data: { label: string, value: string }[]) => void }) => {
  const [x, setX] = useState('2');
  const [y, setY] = useState('5');
  const [resultState, setResultState] = useState<any>(null);

  const calculate = () => {
    const X = parseFloat(parseBrazilianNumber(x)) || 0;
    const Y = parseFloat(parseBrazilianNumber(y)) || 1;

    const ratio = X / Y;
    const percent = ratio * 100;

    const res = { ratio, percent };
    setResultState(res);
    onResultChange([
      { label: 'Razão (X/Y)', value: ratio.toFixed(4) },
      { label: 'Proporção (%)', value: `${percent.toFixed(2)}%` }
    ]);
  };

  return (
    <div className="space-y-8">
      <div className="bg-theme-result p-8 rounded-3xl shadow-lg border border-theme-border">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
          <FormField label="Valor X" value={x} onChange={setX} required isNumeric type="text" />
          <FormField label="Valor Y" value={y} onChange={setY} required isNumeric type="text" />
        </div>

        <div className="flex justify-center mb-8">
          <button
            onClick={calculate}
            className="px-12 py-4 bg-accent-gradient text-white rounded-xl font-bold hover:shadow-accent-hover hover:scale-[1.02] transition-all flex items-center justify-center gap-2"
          >
            <Icon name="play" className="w-5 h-5" />
            Calcular Razão
          </button>
        </div>

        {resultState && (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <ResultCard title="Razão Decimal" value={resultState.ratio.toFixed(4)} color="slate" />
            <ResultCard title="Em Porcentagem" value={`${resultState.percent.toFixed(2)}%`} color="indigo" />
          </div>
        )}
      </div>

      <EducationalBlock
        title="Razão e Proporção"
        tips={[
          'A razão é o quociente entre dois números (X dividido por Y)',
          'Indica quantas vezes uma quantidade está contida na outra',
          'Muito usado em escalas de mapas, receitas e estatísticas',
          'A proporção é a igualdade entre duas razões'
        ]}
      />
    </div>
  );
};

export default RatioProportionCalculator;
